// DO NEVER IMPORT 3RDPARTY IN COMMONM!
// NO: import axios from 'axios';
export class StorageQueryBuilder {
    whereKey = null;
    whereQuery = null;
    limitNumeric = 1000;
    where(whereKey, whereQuery) {
        this.whereKey = whereKey;
        this.whereQuery = whereQuery;
        return this;
    }
    limit(limit) {
        this.limitNumeric = limit;
        return this;
    }
    async getMany() {
        return Promise.resolve({
            results: [
                {
                    value: {
                        users: [],
                        groups: ['team-awesome'],
                    },
                    key: 'fpermv1#1#2#',
                },
            ],
            nextCursor: 'FAJmcGVybXYxIzEjMiMA',
        });
    }
}
export const mockedStorageStartsWith = (x) => `startsWith___${x}`;
export class CodeclouLocalStorage {
    dbService;
    constructor(dbService) {
        this.dbService = dbService;
    }
    //
    // ATLASSIAN STORAGE API METHODS
    //
    get(key) {
        return this.dbService.storageMockGet(key);
    }
    set(key, val) {
        return this.dbService.storageMockSet(key, val);
    }
}
export class FakeLocalStorage {
    fakeDataKeyValue;
    /* use key/value pairs of data */
    constructor(fakeDataKeyValue) {
        this.fakeDataKeyValue = fakeDataKeyValue;
    }
    get(key) {
        // console.log('get hit for key:', key);
        return this.fakeDataKeyValue[key];
    }
    set(key, val) {
        this.fakeDataKeyValue[key] = val;
        return;
    }
}
